import { useState, type FormEvent } from "react";

import { Button, TextField } from "@/components";

type LoginCardProps = {
  /** 주소 뒤에 붙는 도메인. 하나뿐이라 안 쳐도 된다는 것을 보여준다 */
  mailDomain?: string;
  pending?: boolean;
  error?: string | null;
  onSubmit: (credentials: { address: string; password: string }) => void;
};

/** 시안 01 · 첫 로그인 */
export function LoginCard({
  mailDomain,
  pending = false,
  error,
  onSubmit,
}: LoginCardProps) {
  const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    onSubmit({ address: address.trim(), password });
  }

  return (
    <form
      onSubmit={handleSubmit}
      // 좁은 화면에서는 화면 폭을 따라간다. w-100(400px) 고정이면 360px 기기에서
      // 입력칸이 잘려 나간다.
      className="flex w-full max-w-100 flex-col items-center gap-9 px-6"
    >
      <div className="bg-ink text-paper flex size-18 items-center justify-center rounded-3xl text-3xl font-bold">
        @
      </div>

      {/* 레일 상단과 같은 이름이어야 한다. 예전에는 여기만 "Meow"였다 */}
      <h1 className="text-ink text-[28px] font-bold tracking-tight">Cat Mail</h1>

      <div className="flex w-full flex-col gap-3">
        <TextField
          size="xl"
          label="메일 주소"
          autoComplete="username"
          placeholder="이름"
          // 도메인이 하나뿐이라 안 쳐도 된다. 서버가 붙인다.
          trailing={
            mailDomain ? (
              <span className="text-muted-2 text-[15px]">@{mailDomain}</span>
            ) : undefined
          }
          value={address}
          onChange={(event) => setAddress(event.target.value)}
          required
        />

        <TextField
          size="xl"
          label="비밀번호"
          type="password"
          autoComplete="current-password"
          placeholder="비밀번호"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          required
        />

        {error ? (
          <p role="alert" className="text-danger px-1 text-sm">
            {error}
          </p>
        ) : null}

        <Button type="submit" size="xl" block disabled={pending}>
          {pending ? "확인하는 중…" : "시작하기"}
        </Button>
      </div>
    </form>
  );
}
